import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { useNavigate } from 'react-router';

import { Grid, Card, CardHeader, Typography, Divider, CardContent, FormControl, InputLabel, MenuItem, Select, TextField, Button, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, Paper, CircularProgress, IconButton, Dialog, DialogActions, DialogContent } from '@mui/material';

import EditIcon from '@mui/icons-material/Edit';
import DescriptionIcon from '@mui/icons-material/Description';
import UndoIcon from '@mui/icons-material/Undo';

import moment from 'moment';
import 'moment/locale/es-mx';

import { RootState } from '../../store';
import { openSnackbar } from '../../store/slices/SnackbarSlice';

import { usePages } from '../../hooks/usePages';

import { DownloadFile } from '../../helpers/DownloadFile';
import { TablePaginationActions } from '../../helpers/TablePaginationActions';

import { TableTheadStyle, TablePaddingStyle } from '../../styles/TableStyle';
import { DialogActionsStyle, DialogContentStyle } from '../../styles/DialogStyle';

import { Layout } from '../../components/Layout';

import { DialogDocumento } from '../../dialogs/DialogDocumento';
import { DialogExpediente } from '../../dialogs/DialogExpediente';

import { ObtenerAutoridadesMaterias } from '../../connections/catalogos/AutoridadConnection';
import { ObtenerTipoConsecutivo } from '../../connections/catalogos/TipoConsecutivoConnection';
import { ObtenerMateria } from '../../connections/catalogos/MateriaConnection';
import { ObtenerLibroSentenciaDefinitiva, DescargarLibroSentenciaDefinitiva, GuardarObservacionesLibroSentenciaDefinitiva } from '../../connections/libros-electronicos/LibroSentenciaDefinitivaConnection';

import { MateriaProps } from '../../interfaces/catalogos/MateriaInterface';
import { AutoridadProps } from '../../interfaces/catalogos/AutoridadInterface';
import { TipoConsecutivoProps } from '../../interfaces/catalogos/TipoConsecutivoInterface';
import { defaultLibroSentenciaDefinitiva, LibroSentenciaDefinitivaProps } from '../../interfaces/libros-electronicos/LibroSentenciaDefinitivaInterface';

export const LibroCitadosSentenciaDefinitivaPage = () => {

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const { administrador, coordinador } = useSelector( ( state: RootState ) => state.auth );

    const [loading, setLoading] = useState( false );
    const [searching, setSearching] = useState( false );
    const [loadingDescarga, setLoadingDescarga] = useState( false );
    const [loadingObservaciones, setLoadingObservaciones] = useState( false );

    const [openDialogObservaciones, setOpenDialogObservaciones] = useState( false );
    const [openDialogExpediente, setOpenDialogExpediente] = useState( false );
    const [openProrroga, setOpenProrroga] = useState( false );
    const [prorroga, setProrroga] = useState( '' );

    const [openDialogDocumentoSentencia, setOpenDialogDocumentoSentencia] = useState( false );
    const [documentoSentencia, setDocumentoSentencia] = useState( '' );

    const [filtroAplicado, setFiltroAplicado] = useState( false );
    const [recordCount, setRecordCount] = useState( 0 );

    const [numeroReferencia, setNumeroReferencia] = useState( '' );

    const [materia, setMateria] = useState( 0 );
    const [materiaArray, setMateriaArray] = useState<MateriaProps[]>( [] );

    const [autoridad, setAutoridad] = useState( 0 );
    const [autoridadArray, setAutoridadArray] = useState<AutoridadProps[]>( [] );

    const [tipoConsecutivo, setTipoConsecutivo] = useState( 0 );
    const [tipoConsecutivoArray, setTipoConsecutivoArray] = useState<TipoConsecutivoProps[]>( [] );

    const [libroSelected, setLibroSelected] = useState<LibroSentenciaDefinitivaProps>( defaultLibroSentenciaDefinitiva );

    const [rows, setRows] = useState<LibroSentenciaDefinitivaProps[]>( [] );
    const [observaciones, setObservaciones] = useState( '' );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages( 10 );

    const handleClear = () => {

        setNumeroReferencia( '' );

        setMateria( 0 );
        setAutoridad( 0 );
        setAutoridadArray( [] );
        setTipoConsecutivo( 0 );

        resetPage();
        setFiltroAplicado( false );

    }

    const handleBuscar = async () => {

        setSearching( true );
        setLoading( true );
        setRecordCount( 0 );
        setRows( [] );
        setFiltroAplicado( true );

    }

    const handleDescargar = async () => {

        setLoadingDescarga( true );

        await DescargarLibroSentenciaDefinitiva({ idAutoridad: autoridad, numeroReferencia, idTipoConsecutivo: tipoConsecutivo }).then( resp => {

            setTimeout(() => {

                if ( resp ) {

                    DownloadFile( `Libro-sentencias-definitivas-${ Date.now() }.xlsx`, resp );

                    setLoadingDescarga( false );

                }
                else {

                    setLoadingDescarga( false );
                }

            }, 700);

        });

    }

    const handleOpenExpediente = ( value: LibroSentenciaDefinitivaProps ) => {

        setLibroSelected( value );
        setOpenDialogExpediente( true );

    }

    const handleOpenObservaciones = ( value: LibroSentenciaDefinitivaProps ) => {

        setLibroSelected( value );
        setObservaciones( value.observaciones ?? '' );
        setOpenDialogObservaciones( true );

    }

    const handleGuardarObservaciones = async () => {

        setLoadingObservaciones( true );

        await GuardarObservacionesLibroSentenciaDefinitiva({ id: libroSelected.idLibroSentenciaDefinitiva, observaciones }).then( resp => {

            setTimeout(() => {

                const { success, message } = resp;

                if (  success ) {

                    dispatch( openSnackbar({ message, variant: 'success' }));
                    setOpenDialogObservaciones( false );
                    setLoadingObservaciones( false );

                    const newRows = rows.map((elem) => {
                        if (elem.idLibroSentenciaDefinitiva === libroSelected.idLibroSentenciaDefinitiva) {
                            return { ...elem, observaciones: observaciones };
                        }
                        return elem;
                    });
                    setRows(newRows);

                }
                else {

                    dispatch( openSnackbar({ message, variant: 'success' }));
                    setLoadingObservaciones( false );

                }

            }, 700);

        });

    }

    useEffect(() => {

        async function Obtener() {

            await ObtenerMateria().then( resp => {
                setMateriaArray( resp );
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            await ObtenerTipoConsecutivo().then( resp => {
                setTipoConsecutivoArray( resp );
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            setAutoridad( 0 );
            setAutoridadArray( [] );

            await ObtenerAutoridadesMaterias( materia ).then( resp => {
                setAutoridadArray( resp );
            });

        }

        Obtener();

    }, [ materia ]);

    useEffect(() => {

        async function Obtener() {

            setLoading( true );
            setRecordCount( 0 );
            setRows( [] );

            await ObtenerLibroSentenciaDefinitiva({ idAutoridad: 0, numeroReferencia: '', idTipoConsecutivo: 0, page, rowsPerPage }).then( resp => {

                setTimeout(() => {

                    setRecordCount( resp.recordCount );
                    setRows( resp.records );

                    setLoading( false );

                }, 700);

            });

        }

        if ( !filtroAplicado ) {
            Obtener();
        }

    }, [ filtroAplicado, page, rowsPerPage ])

    useEffect(() => {

        async function Obtener() {

            setLoading( true );
            setRecordCount( 0 );
            setRows( [] );

            await ObtenerLibroSentenciaDefinitiva({ idAutoridad: autoridad, numeroReferencia, idTipoConsecutivo: tipoConsecutivo, page, rowsPerPage }).then( resp => {

                setTimeout(() => {

                    setRecordCount( resp.recordCount );
                    setRows( resp.records );

                    setLoading( false );
                    setSearching( false );

                }, 700);

            });

        }

        if ( filtroAplicado ) {
            Obtener();
        }

    }, [ filtroAplicado, autoridad, numeroReferencia, tipoConsecutivo, page, rowsPerPage ])

    return (
        <Layout breadcrumbs={[{ text: 'Libros electrónicos' }, { text: 'Libro de negocios citados para sentencia definitiva y resueltos' }]} backgroundPaper={ false }>

            <Grid container spacing={ 3 }>

                {
                    ( administrador || coordinador )
                    &&
                        <Grid size={{ md: 12, xs: 12 }} textAlign={ 'start' }>

                            <Button startIcon={ <UndoIcon />} color='secondary' variant='text' sx={{ mt: 1 }} onClick={ () => navigate('/') }>
                                Regresar
                            </Button>

                        </Grid>
                }

                <Grid size={{ md: 12, xs: 12 }}>

                    <Card>

                        <CardHeader
                            sx={{ backgroundColor: (theme) => theme.palette.primary.main, py: 2 }}
                            subheader={<Typography sx={{ fontSize: 14, fontWeight: 'bold', color: 'white' }}> Filtro(s) </Typography>}
                        />

                        <Divider />

                        <CardContent sx={{ p: 3 }}>

                            <Grid container spacing={ 3 }>

                                <Grid size={{ md: 2, xs: 12 }}>

                                    <FormControl fullWidth>
                                        <InputLabel>Materia</InputLabel>

                                        <Select
                                            label='Materia'
                                            value={ materia }
                                            onChange={ (e) => setMateria( e.target.value ) }
                                            disabled={ filtroAplicado }

                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                materiaArray
                                                .filter( ({ idMateria }) => idMateria === 5 || idMateria === 6 )
                                                .map(({ idMateria, descripcion }) => (
                                                    <MenuItem key={ idMateria } value={ idMateria }>{ descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>

                                    </FormControl>

                                </Grid>

                                <Grid size={{ md: 3, xs: 12 }}>

                                    <FormControl fullWidth disabled={ materia === 0 || filtroAplicado }>
                                        <InputLabel>Autoridad</InputLabel>

                                        <Select
                                            label='Autoridad'
                                            value={ autoridad }
                                            onChange={ (e) => setAutoridad( e.target.value ) }
                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                autoridadArray.map(({ idAutoridad, descripcion }) => (
                                                    <MenuItem key={ idAutoridad } value={ idAutoridad }>{ descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>

                                    </FormControl>

                                </Grid>

                                <Grid size={{ md: 3, xs: 12 }}>

                                    <FormControl fullWidth disabled={ filtroAplicado }>
                                        <InputLabel>Tipo de consecutivo</InputLabel>

                                        <Select
                                            label='Tipo de consecutivo'
                                            value={ tipoConsecutivo }
                                            onChange={ (e) => setTipoConsecutivo( e.target.value ) }
                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                tipoConsecutivoArray
                                                .filter(({ idTipoConsecutivo }) => idTipoConsecutivo === 1 || idTipoConsecutivo === 4)
                                                .map(({ idTipoConsecutivo, descripcion }) => (
                                                    <MenuItem key={ idTipoConsecutivo } value={ idTipoConsecutivo }>{ descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>

                                    </FormControl>

                                </Grid>

                                <Grid size={{ md: 2, xs: 12 }}>

                                    <TextField
                                        fullWidth
                                        label='Número de referencia'
                                        placeholder='1/2026'
                                        value={ numeroReferencia }
                                        onChange={ (e) => setNumeroReferencia( e.target.value ) }
                                        disabled={ filtroAplicado }
                                        onKeyDown={ (e) => e.key === 'Enter' ? handleBuscar() : {} }
                                        slotProps={{
                                            input: { autoComplete: 'off' },
                                            inputLabel: { shrink: true }
                                        }}
                                    />

                                </Grid>

                                <Grid size={{ md: 2, xs: 12 }}>

                                    <Button
                                        fullWidth
                                        color={ filtroAplicado ? 'secondary' : 'primary' }
                                        variant={ filtroAplicado ? 'outlined' : 'contained' }
                                        loading={ searching }
                                        disabled={ autoridad === 0 || (tipoConsecutivo !== 0 && numeroReferencia === '') }
                                        onClick={ () => { filtroAplicado ? handleClear() : handleBuscar() } }
                                    >
                                        { filtroAplicado ? 'Limpiar filtro' : 'Buscar' }
                                    </Button>

                                </Grid>

                            </Grid>

                        </CardContent>

                    </Card>

                </Grid>

                <Grid size={{ md: 12, xs: 12 }} textAlign={ 'end' }>

                    <Button
                        color='secondary'
                        variant='outlined'
                        loading={ loadingDescarga }
                        onClick={ handleDescargar }
                    >
                       Descargar información
                    </Button>

                </Grid>

                <Grid size={{ md: 12, xs: 12 }}>

                    <TableContainer sx={{ borderRadius: 3 }} component={ Paper }>

                        <Table sx={{ minHeight: rows.length === 0 ? 450 : 0 }}>

                            <TableHead sx={{ ...TableTheadStyle }}>

                                <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold', textAlign: 'center' }}>Sentencia</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold', textAlign: 'center' }}>Expediente</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold', textAlign: 'center' }}>Prórroga</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '12%', fontWeight: 'bold', textAlign: 'center' }}>Fecha de citación</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '12%', fontWeight: 'bold', textAlign: 'center' }}>Fecha de sentencia</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '11%', fontWeight: 'bold' }}>Sentido de la sentencia</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold' }}>Observaciones</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '5%', fontWeight: 'bold' }}></TableCell>

                                </TableRow>

                            </TableHead>

                            <TableBody>

                                {
                                    rows.map( ( elem , index) => {

                                        const { numeroSentencia, numeroExpediente, prorroga, documentoSentencia: docSentencia, fechaCitacionSentencia, fechaSentencia, fechaProrroga, sentidoSentencia, observaciones } = elem;

                                        return <TableRow key={ index } >

                                            <TableCell sx={{ textAlign: 'center' }}>

                                                <Typography variant='subtitle1'>
                                                    <strong>{ numeroSentencia }</strong>
                                                </Typography>

                                                {
                                                    docSentencia
                                                    &&
                                                        <Button
                                                            variant='contained'
                                                            size='small'
                                                            color='primary'
                                                            sx={{ mt: 1 }}
                                                            onClick={ () => { setDocumentoSentencia( docSentencia ); setOpenDialogDocumentoSentencia( true ); } }
                                                        >
                                                            Ver sentencia
                                                        </Button>
                                                }

                                            </TableCell>

                                            <TableCell>

                                                <Button
                                                    fullWidth
                                                    variant='contained'
                                                    onClick={ () => handleOpenExpediente( elem ) }
                                                >
                                                    { numeroExpediente }
                                                </Button>

                                            </TableCell>

                                            <TableCell sx={{ textAlign: 'center' }}>

                                                {
                                                    prorroga
                                                    &&
                                                        <>
                                                            <IconButton onClick={ () => { setOpenProrroga( true ); setProrroga( prorroga ); } } color='primary'>
                                                                <DescriptionIcon fontSize='large' />
                                                            </IconButton>

                                                            <Typography variant='body1' fontWeight={ 'bold' }> Fecha Prórroga </Typography>
                                                            <Typography variant='subtitle1'> { moment( fechaProrroga ).format('DD-MM-YYYY') } </Typography>
                                                        </>
                                                }

                                            </TableCell>

                                            <TableCell sx={{ textAlign: 'center' }}>

                                                {
                                                    fechaCitacionSentencia
                                                    &&
                                                        <>

                                                            <Typography variant='subtitle1'>
                                                                { moment( fechaCitacionSentencia ).format('DD-MM-YYYY') }
                                                            </Typography>

                                                            <Typography variant='caption' color='text.secondary'>
                                                                { moment( fechaCitacionSentencia ).format('hh:mm a') }
                                                            </Typography>

                                                        </>
                                                }

                                            </TableCell>

                                            <TableCell sx={{ textAlign: 'center' }}>

                                                {
                                                    fechaSentencia
                                                    &&
                                                        <>

                                                            <Typography variant='subtitle1'>
                                                                { moment( fechaSentencia ).format('DD-MM-YYYY') }
                                                            </Typography>

                                                            <Typography variant='caption' color='text.secondary'>
                                                                { moment( fechaSentencia ).format('hh:mm a') }
                                                            </Typography>

                                                        </>
                                                }

                                            </TableCell>

                                            <TableCell> { sentidoSentencia } </TableCell>

                                            <TableCell sx={{ whiteSpace: "normal", wordBreak: "break-word" }}> { observaciones } </TableCell>

                                            <TableCell>

                                                <IconButton color='primary' onClick={ () => handleOpenObservaciones( elem ) }>
                                                    <EditIcon />
                                                </IconButton>

                                            </TableCell>

                                        </TableRow>

                                    })
                                }

                                {
                                    ( rows.length === 0 && !loading )
                                    ?
                                        <TableRow style={{ height: 73 }}>

                                            <TableCell colSpan={ 8 } align='center'>

                                                <Typography variant='caption' color='secondary'> No se encontraron resultados </Typography>

                                            </TableCell>

                                        </TableRow>
                                    :
                                        loading
                                        &&
                                            <TableRow style={{ height: 73 }}>

                                                <TableCell colSpan={ 8 } align='center'>

                                                    <CircularProgress size={ 32 } />

                                                </TableCell>

                                            </TableRow>
                                }

                            </TableBody>

                            <TableFooter>

                                <TableRow>

                                    <TableCell colSpan={ 2 }>
                                        <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}> Total de registros: { recordCount } </Typography>
                                    </TableCell>

                                    <TablePagination
                                        colSpan={ 6 }
                                        rowsPerPageOptions={ [ 5, 10, 15, 25, 50, 75, 100, 150, 200, 500 ] }
                                        count={ recordCount }
                                        rowsPerPage={ rowsPerPage }
                                        page={ page }
                                        onPageChange={ handleChangePage }
                                        onRowsPerPageChange={ handleChangeRowsPerPage }

                                        ActionsComponent={ TablePaginationActions }

                                        labelRowsPerPage='Filas por página'
                                        labelDisplayedRows={
                                            ({ from, to, count }) => {
                                                return '' + from + '-' + to + ' de ' + count
                                            }
                                        }
                                    />
                                </TableRow>

                            </TableFooter>

                        </Table>

                    </TableContainer>

                </Grid>

            </Grid>

            <DialogExpediente
                expediente={ libroSelected.expediente }
                openDialog={ openDialogExpediente }
                handleCloseDialog={ () => setOpenDialogExpediente( false ) }
            />

            <DialogDocumento
                documento={ prorroga }
                openDialog={ openProrroga }
                handleCloseDialog={ () => setOpenProrroga( false ) }
            />

            <DialogDocumento
                documento={ documentoSentencia }
                openDialog={ openDialogDocumentoSentencia }
                handleCloseDialog={ () => setOpenDialogDocumentoSentencia( false ) }
            />

            <Dialog
                fullWidth
                maxWidth='sm'
                open={ openDialogObservaciones }
            >

                <DialogContent sx={ DialogContentStyle }>

                    <TextField
                        sx={{ mt: 1 }}
                        label='Observaciones'
                        variant='outlined'
                        multiline
                        rows={ 4 }
                        fullWidth
                        value={ observaciones }
                        onChange={ (e) => setObservaciones( e.target.value ) }
                        slotProps={{
                            input: { autoComplete: 'off' },
                            inputLabel: { shrink: true }
                        }}
                    />

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>

                    <Button color='secondary' disabled={ loadingObservaciones } onClick={ () => setOpenDialogObservaciones( false ) }>Cancelar</Button>
                    <Button variant='contained' loading={ loadingObservaciones } onClick={ handleGuardarObservaciones }>Guardar</Button>

                </DialogActions>

            </Dialog>

        </Layout>
    )
}